import { render } from "./SchoolServiceMonthlyContainer.vue?vue&type=template&id=4faee827&scoped=true&ts=true"
import script from "./SchoolServiceMonthlyContainer.vue?vue&type=script&lang=ts"
export * from "./SchoolServiceMonthlyContainer.vue?vue&type=script&lang=ts"

import "./SchoolServiceMonthlyContainer.vue?vue&type=style&index=0&id=4faee827&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4faee827"]])

export default __exports__